<template>
  <div class="historybill">
    <el-form :inline="true" :model="queryInfo" class="form" style="margin-bottom: -10px;">
      <el-row :gutter="24">
        <el-col style="display: flex;flex-direction: row;">
          <el-form-item label="所属电站" label-width="110px" style="display:flex;flex-direction:row;margin-left: -40px;">
            <el-select v-model="suoshudianzhan" placeholder="请选择所属电站" @change="change_value" clearable
              @clear="getPowerStationList" filterable>
              <el-option v-for="(item, index) in powerStationList" :key="index" :label="item.stationName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号|路别" label-width="120px" style="display:flex;flex-direction:row;margin-left: -40px">
            <el-input placeholder="请输入手机号或路别" clearable @change="xiugai" v-model="queryInfo.phone"
              @clear="getPowerStationList">
            </el-input>
          </el-form-item>
          <el-form-item label="车牌号" label-width="110px" style="display:flex;flex-direction:row;margin-left: -70px">
            <el-input placeholder="请输入车牌号" clearable @change="getPowerStationList" v-model="queryInfo.carNum"
              @clear="getPowerStationList">
            </el-input>
          </el-form-item>
          <el-form-item label="Vin主账户" v-if="VinAll.length > 0" label-width="110px"
            style="display:flex;flex-direction:row;margin-left: -50px">
            <el-select v-model="VinMain" placeholder="请选择vin主账户" clearable @clear="getPowerStationList" filterable>
              <el-option v-for="(item, index) in VinAll" :key="index" :label="item.companyName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="微信主账号" label-width="110px" style="display:flex;flex-direction:row;margin-left: -40px">
            <el-input placeholder="请输入微信主账号" clearable @change="xiugai2" v-model="queryInfo.wxPhone"
              @clear="getPowerStationList">
            </el-input>
          </el-form-item>
          <div v-if="!zhuangkuang" style="display: flex;flex-direction: row;margin-left: -10px">
            <li>
              <button @click="chaxun" class="buttons">
                <i class="el-icon-search" style="font-size: 14px;"></i>
                <span>查询</span>
              </button>
            </li>
            <li style="margin: 0 10px;">
              <button @click="chongzhi" class="buttons"><i class="el-icon-refresh-right"
                  style="font-size: 14px;"></i><span>重置</span>
              </button>
            </li>
            <li>
              <button @click="jizaigengduo" class="buttons">
                <i class="el-icon-check" style="font-size: 14px;"></i><span>更多筛选</span>
              </button>
            </li>
          </div>
        </el-col>
        <el-col v-if="zhuangkuang" style="display: flex;flex-direction: row;margin-top: -10px;">
          <el-form-item label="支付方式" label-width="100px" style="display:flex;flex-direction:row">
            <el-select v-model="queryInfo.cardsType" clearable placeholder="请选择支付方式" @clear="getPowerStationList"
              filterable>
              <el-option v-for="(value, key, index) in cardsTypeList" :key="index" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充电车主" label-width="110px" style="display:flex;flex-direction:row">
            <el-input placeholder="请输入充电车主" clearable @change="getPowerStationList" v-model="queryInfo.icCode"
              @clear="getPowerStationList">
            </el-input>
          </el-form-item>
          <el-form-item label="电桩编号" label-width="110px" style="display:flex;flex-direction:row">
            <el-input placeholder="请输入电桩编号" clearable @change="getPowerStationList" v-model="queryInfo.pileCode"
              @clear="getPowerStationList">
            </el-input>
          </el-form-item>
          <el-form-item label="订单编号" label-width="110px" style="display:flex;flex-direction:row">
            <el-input placeholder="请输入订单号" clearable @change="getPowerStationList" v-model="queryInfo.billCode"
              @clear="getPowerStationList" style="width: 400px;">
            </el-input>
          </el-form-item>
          <el-form-item label="桩类型" label-width="100px" style="display:flex;flex-direction:row">
            <el-select v-model="queryInfo.pileType" clearable placeholder="请选择工作状态" @change="chage_zhuangType"
              @clear="getPowerStationList" filterable>
              <el-option v-for="(item, index) in pileType_list" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-select v-model="queryInfo.pileType" placeholder="请选择" @change="chage_zhuangType" filterable clearable
                @clear="getPowerStationList" style="width: 120px;">
                <el-option v-for="item in zhuangTypelist" :key="item.pileType" :label="item.stationName"
                  :value="item.pileType">
                </el-option>
              </el-select> -->
          </el-form-item>
        </el-col>
        <!-- :span="4" -->
        <el-col v-if="zhuangkuang" style="display: flex;flex-direction: row;margin-top: -10px;">
          <el-form-item label="选择时间" label-width="110px" style="display:flex;flex-direction:row">
            <el-date-picker type="datetimerange" @blur="pickBlur" :picker-options="pickerOptions" v-model="values"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" @change="changeTime">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="启动方式" label-width="110px" style="display:flex;flex-direction:row">
            <el-select v-model="queryInfo.startType" placeholder="请选择订单启动方式" @change="chage_startType" filterable
              clearable @clear="getPowerStationList">
              <el-option v-for="(item, index) in startTypelist" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式" label-width="110px" style="display:flex;flex-direction:row">
            <el-select v-model="shifou" placeholder="请选择订单支付方式" @change="chage_isPay" filterable clearable
              @clear="getPowerStationList">
              <el-option v-for="(item, index) in isPay" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="无效订单" label-width="110px" style="display:flex;flex-direction:row">
            <el-select v-model="queryInfo.defaultValue" placeholder="请选择订单状态" clearable @change="current"
              @clear="getPowerStationList" filterable>
              <el-option v-for="(item, index) in invalidOrder" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务器类型" label-width="110px" style="display:flex;flex-direction:row">
            <el-select v-model="queryInfo.serverType" placeholder="请选择服务器类型" clearable @change="current"
              @clear="getPowerStationList" filterable>
              <el-option v-for="(item, index) in serverTypeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        </el-col>
        <li class="tils" v-if="zhuangkuang">
          <button @click="chaxun" class="buttons">
            <i class="el-icon-search" style="font-size: 12px;"></i><span>查询</span>
          </button>
          <button @click="chongzhi" class="buttons"><i class="el-icon-refresh-right"
              style="font-size: 12px;"></i><span>重置</span></button>
          <button @click="jizaigengduo" class="buttons"><i class="el-icon-check"
              style="font-size: 12px;"></i><span>更多筛选</span></button>
        </li>
      </el-row>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card class="card">
      <li style="margin-bottom: 10px;display: flex;justify-content: flex-end;margin-top: -10px;">
        <el-button type="primary" icon="el-icon-download" @click="daochu">导出</el-button>
      </li>
      <div class="listname" v-if="listall.length > 0">
        <div class="dl" v-for="(item, index) in listall" :key="index">
          <div class="p">
            {{ item.name }}
          </div>
          <div class="p">
            {{ index !== 0 ? timesalls(item.countMoney, 100, 2) : timesalls(item.countMoney, 100, 4) }}
          </div>
        </div>
      </div>
      <!--  -->
      <!-- table表格区域 -->
      <el-table class="table" :data="chargingList" border @row-dblclick="dbclick" :lazy="true" empty-text="暂无数据">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" class="demo-table-expand">
              <el-row :gutter="20" style="display: flex;flex-direction: row;padding: 0 1%;">
                <el-col :span="6" style="display: flex;flex-direction: column;">
                  <el-form-item label="订单编号：">
                    <span v-if="scope.row.startType == 5">{{ scope.row.billCode }}</span>
                    <span v-else>{{ time_all(scope.row) }}</span>
                    <span v-if="scope.row.billCode == null">--</span>
                  </el-form-item>
                  <el-form-item label="电桩编号：">
                    <span v-if="scope.row.pileCode">{{ scope.row.pileCode }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                  <el-form-item label="开始时间：">
                    <span v-if="scope.row.startTime">{{ scope.row.startTime }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                  <el-form-item label="结束时间：">
                    <span v-if="scope.row.endTime">{{ scope.row.endTime }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="display: flex;flex-direction: column;">
                  <el-form-item label="充电车主：">
                    <span v-if="scope.row.icCode !== null">{{ scope.row.icCode }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                  <el-form-item label="车牌号：">
                    <span v-if="scope.row.carNum !== null">{{ scope.row.carNum }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                  <el-form-item label="车架号：">
                    <span v-if="scope.row.carvin">{{ scope.row.carvin }}</span>
                    <span v-else> -- </span>
                  </el-form-item>
                  <el-form-item label="结束原因："><span>{{ scope.row.stopReason }}</span></el-form-item>
                </el-col>
                <el-col :span="6" style="display: flex;flex-direction: column;">
                  <el-form-item label="尖时电量（度）：">
                    <span v-if="scope.row.tipKwh">{{ timesalls(scope.row.tipKwh, 100, 4) }}度</span>
                    <span v-else> 0 度</span>
                  </el-form-item>
                  <el-form-item label="峰时电量（度）：">
                    <span v-if="scope.row.peakKwh">{{ timesalls(scope.row.peakKwh, 100, 4) }}度</span>
                    <span v-else> 0 度</span>
                  </el-form-item>
                  <el-form-item label="平时电量（度）：">
                    <span v-if="scope.row.flatKwh">{{ timesalls(scope.row.flatKwh, 100, 4) }}度</span>
                    <span v-else> 0 度</span>
                  </el-form-item>
                  <el-form-item label="谷时电量（度）：">
                    <span v-if="scope.row.valleyKwh">{{ timesalls(scope.row.valleyKwh, 100, 4) }}度</span>
                    <span v-else> 0 度</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="display: flex;flex-direction: column;">
                  <el-form-item label="开始SOC：">
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.startSoc"
                      status="success"></el-progress>
                  </el-form-item>
                  <el-form-item label="当前SOC：">
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.nowSoc"
                      status="success"></el-progress>
                  </el-form-item>
                  <el-form-item label="充电时长（分钟）：">
                    <span>{{ timesalls(scope.row.lengthTime, 60, 0) }}分钟</span>
                  </el-form-item>
                  <el-form-item label="扣款方式：">
                    <span>{{ typeNames(scope.row) }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电桩编号" prop="pileCode" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.pileCode }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号|路别" prop="phone" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.phone == null || scope.row.phone == '' || scope.row.phone == '' ? '--' : scope.row.phone
              }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="枪号" prop="gunNumber" width="70">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.gunNumber == 1 ? '' : scope.row.gunNumber == 2 ? 'success' : scope.row.gunNumber == 3 ? 'warning' : 'danger'"
              v-if="scope.row.gunNumber == 1 || scope.row.gunNumber == 2 || scope.row.gunNumber == 3 || scope.row.gunNumber == 4">{{
      scope.row.gunNumName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="开始时间" prop="startTime" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime == null ? '--' : scope.row.startTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结束时间" prop="endTime" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.endTime == null ? '--' : scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="充电SOC" prop="nowSoc" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.nowSoc }}%</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="充电功率" prop="chargeKwh" width="80">
          <template slot-scope="scope">
            <span>{{ jisuan(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电量（度）" prop="totalKwh" width="100">
          <template slot-scope="scope">
            <span>{{ timesalls(scope.row.totalKwh, 100, 4) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电费  |  服务费（元）" width="170">
          <template slot-scope="scope">
            <el-col>
              <span>￥{{ timesalls(scope.row.chargemoney, 100, 2) }}&emsp;|&emsp;</span>
              <span
                v-if="scope.row.chargemoneygive == 0 && scope.row.servicemoneygive == 0 && scope.row.billMoneygive == 0"></span>
              <span>￥{{ timesalls(scope.row.servicemoney, 100, 2) }}</span>
            </el-col>
            <el-col
              v-if="scope.row.chargemoneygive == 0 && scope.row.servicemoneygive == 0 && scope.row.billMoneygive == 0"></el-col>
            <el-col v-else>
              <span style="color: green;font-size: 14px;">
                ￥{{ timesalls(scope.row.chargemoneygive, 100, 2) }}&emsp;|&emsp;</span>
              <span></span>
              <span style="color: green;font-size: 14px;">
                ￥{{ timesalls(scope.row.servicemoneygive, 100, 2) }}</span>
            </el-col>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总费用  |  优惠（元）" prop="billMoney" width="170">
          <template slot-scope="scope">
            <span>￥{{ timesalls(scope.row.billMoney, 100, 2) }}&emsp;|&emsp;</span><span
              style="color: green;font-size: 14px;">￥{{ timesalls(scope.row.billMoneygive, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="实付金额" width="80">
          <template slot-scope="scope">
            <span>￥{{ shifu(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="启动方式" prop="startType" width="80">
          <template slot-scope="scope">
            <img style="width: 40px;
           height: 40px;" :src="scope.row.startType == 0 || scope.row.startType == 9 ? tupian + '小程序.png' : scope.row.startType == 1 ? tupian + '在线卡.png' : scope.row.startType == 2 ? tupian + '离线卡.png' : scope.row.startType == 3 ? tupian + '管理卡.png' : scope.row.startType == 4 ? tupian + 'Vin.png' : scope.row.startType == 5 ? tupian + 'hlht.png' : scope.row.startType == 6 ? tupian + 'zfb.png' :
      scope.row.startType == 9 ? tupian + 'app.png' : tupian + 'ocpp_App.png'" alt="">
          </template>
        </el-table-column>
        <el-table-column align="left" label="所属电站" prop="stationName" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span>
              {{ scope.row.stationName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否支付" prop="payState" width="80">
          <template slot-scope="scope">
            <el-tag type="info">{{ scope.row.payTypeName }}</el-tag>
          </template>
        </el-table-column>
        <!-- v-if="qushitu" -->
        <el-table-column width="120" label="操作" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button type="info" size="small" @click="editMethods(scope.row)">修改订单状态</el-button> -->
            <span v-if="scope.row.pileType == 5 || scope.row.pileType == 6 || scope.row.pileType == 7"></span>
            <el-button type="primary" size="small" @click="EleticMask(scope.row)" v-else>充电趋势图</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[6, 20, 50, 100]" :current-page="queryInfo.page" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
    <!-- @open="open" -->
    <el-dialog title="电量电流趋势图" :visible.sync="diaload" width="80%" top='1vh' :lock-scroll="false" @close="closeMethods">
      <div class="centerList">
        <iframe :src="embeddedUrl" class="embedded-frame" frameborder="0" scrolling="auto">
        </iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import caozuo from "@/utils/pubilc.js";
import { saveBlobToFile } from '@/utils/saveBlobToFile';
import * as echarts from 'echarts';
export default {
  name: 'chargingWorld',
  data() {
    return {
      embeddedUrl: '',
      serverTypeList: [
        {
          value: 0,
          label: 'PHP'
        },
        {
          value: 1,
          label: 'Netty'
        },
      ],
      qushitu: false,
      diaload: false,
      timeJson: [],
      VinMain: null,
      VinAll: [],
      // 需求电流
      currentDemandJson: [],
      // 需求电压
      requiredVoltageJson: [],
      // 满足电流
      outputCurrentJson: [],
      // 满足电压
      outputVoltageJson: [],
      // 电压输出
      voltageOutputValueJson: [],
      // 电流输出满足率
      outputCurrentRateJson: [],
      // 电压输出满足率
      outputVoltageRateJson: [],
      // 输出电流功率
      outputPowerJson: [],
      // 輸出电压功率
      outputYaJson: [],
      listall: [],
      caozuoquanxian: false,
      zhuangkuang: false,
      values: ['', ''],
      shifou: null,
      daochuanniu: false,
      chongzhianiu: false,
      chaxuananiu: false,
      pileType_list: [
        {
          value: 0,
          label: '锐创直流桩'
        },
        {
          value: 1,
          label: '锐创交流桩'
        },
        {
          value: 2,
          label: '无疆(二代)交流桩'
        },
        {
          value: 3,
          label: '光法(一代)直流桩'
        },
        {
          value: 4,
          label: '光法(一代)交流桩'
        },
        {
          value: 5,
          label: '锐创低速桩'
        },
        {
          value: 6,
          label: '其他电桩'
        }
      ],
      // zhuangTypelist: [],
      startTypelist: [
        {
          label: "小程序",
          value: 0
        },
        {
          label: "在线卡",
          value: 1
        },
        {
          label: "离线卡",
          value: 2
        },
        {
          label: "管理卡",
          value: 3
        },
        {
          label: "Vin",
          value: 4
        },
        {
          label: "互联互通",
          value: 5
        }, {
          label: "支付宝",
          value: 6
        },
        {
          label: "APP",
          value: 9
        },
        {
          label: "OCPP_APP",
          value: 9
        },
      ],
      tupian: this.$imgUrls,
      maxValue: 0,
      // 查询充电订单列表所需参数
      queryInfo: {
        defaultValue: null,
        billCode: null,
        pileCode: null,
        pileType: null,
        gunState: '0,3,4,5,6,7',
        userNum: null,
        icCode: null,
        payState: null,
        startTime: null,
        endTime: null,
        carNum: null,
        page: 1,
        limit: 6,
        stationIds: null,
        roleId: window.sessionStorage.getItem('roleId'),
        startType: null,
        phone: null,
        billInfoType: 0,
        wxPhone: null,
        cardsType: '',
        serverType: null
      },
      socJson: '',
      page_num: 0,
      // 充电订单数据
      chargingList: [],
      stateName: '',
      total: 0,
      value: '',
      detailList: [],
      pickerMinDate: '',
      cardsTypeList: {
        0: '账户余额',
        1: '亲情钱包',
        2: '即充即退',
        3: '绑定金额',
        4: '离线刷卡',
        5: '在线刷卡',
        6: '超级卡',
        7: 'VIN',
        8: '其他',
        9: '互联互通',
      },
      pickerOptions: {
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
          const start = this.formatDate(obj.minDate, 'start')
          const end = this.formatDate(obj.maxDate, 'end')
          obj.maxDate && (this.values = [start, end])
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const oneMonth = 1000 * 3600 * 24 * 31
            const maxTime = this.pickerMinDate + oneMonth
            const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
            const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
            return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
          }
        }
      },
      // 电站列表数据
      powerStationList: [],
      shuchufalse: [],
      // 是否已支付
      isPay: [
        {
          label: "已支付",
          value: 1
        },
        {
          label: "未支付",
          value: 0
        }
      ],
      maxValue2: 0,
      // 是否无效订单数据
      invalidOrder: [
        {
          label: "是",
          value: 0
        },
        {
          label: "否",
          value: 1
        }
      ],
      suoshudianzhan: 0,
    }
  },
  computed: {
    typeNames() {
      return function (val) {
        const { cardsType } = val;
        return this.cardsTypeList[Number(cardsType)] || '未知类型'
      }
    },
    time_all() {
      return function (val) {
        const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
        return hr
      }
    },
    timesalls() {
      return function (value, num, count) {
        return (value / num).toFixed(count)
      }
    },
    shifu() {
      return function (val) {
        return ((val.billMoney - val.billMoneygive - val.chargemoneygive - val.servicemoneygive) / 100).toFixed(2)
      }
    },
    jisuan() {
      return function (val) {
        return val.chargeKwh == null || val.chargeKwh == undefined || val.chargeKwh == '' ? 0 : val.pileType !== 5 ? (val.chargeKwh / 100000).toFixed(4) : val.chargeKwh
      }
    }
  },
  watch: {
    chargingList: {
      handler(newval, oldval) {
        this.chargingList = newval
      }
    }
  },
  created() {
    caozuo(244).then(res => {
      this.qushitu = res;
    });
    caozuo(165).then(res => {
      this.caozuoquanxian = res;
    })
    this.VinGet();
    this.getPowerStationList()
  },
  methods: {
    xiugai() {
      const { phone } = this.queryInfo;
      if (!phone || phone == undefined || phone == '') {
        this.$delete(this.queryInfo, 'phone');
      }
      this.getPowerStationList()
    },
    xiugai2() {
      const { wxPhone } = this.queryInfo;
      if (!wxPhone || wxPhone == undefined || wxPhone == '') {
        this.$delete(this.queryInfo, 'wxPhone');
      }
      this.queryInfo.startType = !this.queryInfo.startType || this.queryInfo.startType == undefined || this.queryInfo.startType == '' ? 0 : this.queryInfo.startType;
      this.getPowerStationList();
    },
    VinGet() {
      const stationIds = window.sessionStorage.getItem('stationIds');
      const roleId = window.sessionStorage.getItem('roleId');
      const adminId = window.sessionStorage.getItem('adminId');
      var abc = {
        roleId: roleId,
        stationIds: stationIds,
        adminId: adminId,
        limit: 100
      }
      if (!this.suoshudianzhan || this.suoshudianzhan == '' || this.suoshudianzhan == 0) {
        if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
          this.$delete(abc, 'stationIds')
        } else {
          abc.stationIds = stationIds
        }
      }
      // this.VinAll = [
      //   {
      //     id: 0,
      //     stationName: '全部电站',
      //   }
      // ];

      this.$http.get('charge-vin-total/getAllChargeVinTotal', {
        params: abc
      }).then(res => {
        const ress = res.data;
        if (ress.code > 0) return this.VinAll = [];
        this.VinAll = ress.data
      })
    },
    closeMethods() {
      this.diaload = false;
      const myChart1 = document.getElementById('main1');
      const myChart2 = document.getElementById('main2');
      if (myChart1) {
        echarts.init(myChart1).clear();
      }
      if (myChart2) {
        echarts.init(myChart2).clear();
      }
    },
    editMethods(el) {
      this.$http.post('bill-info/updateStatusById', {
        id: el.id,
        payState: 1
      }).then(res => {
        this.$message.success('订单状态修改成功！')
        // console.log(res,678);
      })
    },
    EleticMask(el) {
      const { billCode } = el;
      const abc = window.sessionStorage.getItem('开发模式');
      const ace = {
        'PROD': 'https://sendnetty.rcdqiot.com/',
        'TEST': 'http://1.193.163.25:8711/'
      }
      this.embeddedUrl = ace[abc] + 'charge_curve.html?billCode=' + billCode;
      this.diaload = true;
      console.log(this.embeddedUrl, 675)
    },
    pickBlur() {
      this.pickerMinDate = ''
    },
    formatDate(datetime, type) {
      const time = new Date(datetime)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = (time.getDate()).toString().padStart(2, '0')
      return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
    },
    getDate() {
      const start = new Date()
      this.values[0] = this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30, 'start')
      this.values[1] = this.formatDate(start.getTime(), 'end')
    },
    zhanshi() {
      this.yincang = !this.yincang
    },
    daochu() {
      const { startTime, endTime, phone, startType, carNum, carvin, pileCode, icCode, wxPhone } = this.queryInfo;
      if (!startTime || !endTime) {
        this.$message.error('请选择你要导出的电站、时间');
        return;
      }
      const roleId = window.sessionStorage.getItem('roleId');
      let obj = {
        startTime: startTime,
        endTime: endTime,
        stationIds: this.suoshudianzhan,
        adminId: window.sessionStorage.getItem('adminId') * 1,
        phone: phone,
        startType: startType,
        carNum: carNum,
        carvin: carvin,
        pileCode: pileCode,
        icCode: icCode,
        wxPhone: wxPhone
      };
      if (this.suoshudianzhan == 0) {
        if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
          this.$delete(obj, 'stationIds');
          this.$message.error('导出请选择场站！')
          return;
        } else {
          obj.stationIds = window.sessionStorage.getItem('stationIds')
        }
      }
      if (!carvin || carvin == '') {
        this.$delete(obj, 'carvin');
        this.$delete(this.queryInfo, 'carvin');
      }
      // if (this.wxPhone !== null && this.wxPhone !== '') {
      //   obj.phone = this.phoneMain
      // }
      if (this.VinMain !== null && this.VinMain !== '') {
        obj.cardsId = this.VinMain;
        obj.startType = 4;
      } else {
        this.$delete(obj, 'cardsId')
      }
      console.log(obj, '974');
      if (obj.startType == 4) {
        // if (obj.phone == '' || obj.phone == null) return this.$message.error('请输入需要导出的路别')
        this.com1(obj);
      } else {
        this.com1(obj)
      }

    },
    com1(obj) {
      console.log(obj, '950');
      this.$http.get('bill-info/export', {
        responseType: 'blob',
        params: obj
      }).then(res => {
        if (res.headers['content-type']?.includes('application/json')) {
          this.$message.error('无符合条件的订单！');
        } else {
          saveBlobToFile(res.data, '历史订单电站列表');
          this.$message.success('文件导出成功');
        }
      })
    },
    jizaigengduo() {
      this.zhuangkuang = !this.zhuangkuang;
    },

    changeTime(value) {
      this.queryInfo.page = 1;
      if (value) {
        this.queryInfo.startTime = value[0];
        this.queryInfo.endTime = value[1];
        if (this.queryInfo.startTime == this.queryInfo.endTime) {
          this.$message.error('起始时间不得为同一天！');
          this.queryInfo.startTime = ''
          this.queryInfo.endTime = ''
        }
      } else {
        this.queryInfo.startTime = null
        this.queryInfo.endTime = null
        this.pickerMinDate = '';
        this.getPowerStationList()
      }
    },
    change_value(e) {
      this.queryInfo.page = 1;
      if (e !== null || e !== undefined) {
        this.queryInfo.stationIds = e;
      }
    },
    // 启动方式
    chage_startType(e) {
      this.queryInfo.page = 1;
      if (e !== null || e !== undefined) {
        this.queryInfo.startType = e;
        // this.queryInfo.pileType = e;
      }
    },
    // 桩类型
    chage_zhuangType(e) {
      this.queryInfo.page = 1;
      if (e !== null || e !== undefined) {
        // this.queryInfo.startType = e;
        this.queryInfo.pileType = e;
      }
    },
    current() {
      this.queryInfo.page = 1;
    },
    // 支付方式
    chage_isPay(e) {
      this.queryInfo.page = 1;
      if (e !== null || e !== undefined) {
        this.queryInfo.payState = e;
      }
    },
    // 重置搜索条件
    chongzhi() {
      this.chongzhianiu = true;
      this.VinMain = null;
      this.queryInfo = {
        defaultValue: null,
        billCode: null,
        pileCode: null,
        pileType: null,
        gunState: '0,3,4,5,6,7',
        userNum: null,
        icCode: null,
        payState: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 6,
        stationIds: null,
        roleId: window.sessionStorage.getItem('roleId'),
        startType: null,
        carNum: null,
        phone: null,
        billInfoType: 0,
        wxPhone: '',
        cardsType: '',
        serverType: null
      };
      this.shifou = '';
      this.suoshudianzhan = 0;
      this.values = [];
      this.pickerMinDate = '';
      this.getPowerStationList();
      setTimeout(() => {
        this.chongzhianiu = false;
      }, 500);
    },
    chaxun() {
      this.chaxuananiu = true;
      this.queryInfo.page = 1;
      this.getPowerStationList();
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.getPowerStationList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage;
      this.getPowerStationList()
    },
    // 获取电站列表数据
    getPowerStationList() {
      const stationIds = window.sessionStorage.getItem('stationIds');
      const roleId = window.sessionStorage.getItem('roleId');
      this.chargingList = [];
      this.listall = [];
      // if (this.queryInfo.stationIds == null || this.queryInfo.stationIds == undefined) return;
      if (this.queryInfo.billCode !== null && this.queryInfo.billCode !== '' && this.queryInfo.billCode !== undefined) {
        this.queryInfo.billCode = this.queryInfo.billCode.trim().split(" ").join("");
      }
      if (this.queryInfo.icCode !== null && this.queryInfo.icCode !== '' && this.queryInfo.icCode !== undefined) {
        this.queryInfo.icCode = this.queryInfo.icCode.trim().split(" ").join("");
      }
      if (!this.queryInfo.serverType) {
        this.$delete(this.queryInfo, 'serverType')
      }

      let ntr = this.queryInfo;
      let obj = {
        roleId: roleId,
        stationIds: this.suoshudianzhan == 0 ? stationIds : this.suoshudianzhan,
        startTime: ntr.startTime,
        endTime: ntr.endTime,
        icCode: ntr.icCode,
        phone: ntr.phone,
        payState: ntr.payState,
        startType: ntr.startType,
        pileCode: ntr.pileCode,
        wxPhone: ntr.wxPhone,
        cardsId: this.VinMain,
        adminId: window.sessionStorage.getItem('adminId'),
        cardsType: ntr.cardsType
      };
      if (!this.queryInfo.startTime || !this.queryInfo.endTime) {
        this.$delete(this.queryInfo, 'startTime')
        this.$delete(this.queryInfo, 'endTime')
        this.$delete(ntr, 'startTime')
        this.$delete(ntr, 'endTime')
        this.$delete(obj, 'startTime')
        this.$delete(obj, 'endTime')
      }
      if (!this.queryInfo.cardsType || this.queryInfo.cardsType == '') {
        this.$delete(this.queryInfo, 'cardsType')
        this.$delete(ntr, 'cardsType')
        this.$delete(obj, 'cardsType')
      }
      let acc = {
        roleId: roleId,
        stationIds: stationIds,
        stationMode: '0,1,2'
      }
      if (this.VinMain !== null && this.VinAll !== '') {
        ntr.cardsId = this.VinMain;
        ntr.startType = 4;
      } else {
        this.$delete(ntr, 'cardsId')
      }

      if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) { this.$delete(acc, 'stationIds') }
      if (!this.suoshudianzhan || this.suoshudianzhan == '' || this.suoshudianzhan == 0) {
        if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
          this.$delete(this.queryInfo, 'stationIds')
          this.$delete(ntr, 'stationIds')
          this.$delete(obj, 'stationIds')

        } else {
          ntr.stationIds = stationIds;
        }
      }
      this.$http.get('bill-info/getAllBillInfo', { params: ntr }).then(res => {
        this.chargingList = res.data.code == 0 ? res.data.data : [];
        this.total = res.data.code == 0 ? res.data.count : 0;
      });

      this.$http.get('bill-info/getAllBillInfoCount', {
        params: obj
      }).then(ress => {
        const res1 = ress.data;
        this.listall = [
          {
            name: '充电电量（度）',
            countMoney: res1.code == 0 ? res1.data.totalBillKwhs : 0
          },
          {
            name: '电费总额（元）',
            countMoney: res1.code == 0 ? res1.data.totalBillMoney - res1.data.totalServiceMoney : 0
          },
          {
            name: '服务费总额（元）',
            countMoney: res1.code == 0 ? res1.data.totalServiceMoney : 0
          },
          {
            name: '充电总额（元）',
            countMoney: res1.code == 0 ? res1.data.totalBillMoney : 0
          },
          {
            name: '充电优惠总额（元）',
            countMoney: res1.code == 0 ? res1.data.totalDiscountMoney : 0
          },
          {
            name: '实收总额（元）',
            countMoney: res1.code == 0 ? res1.data.totalBillMoney - res1.data.totalDiscountMoney : 0
          }
        ];
      })
      // this.listall = [
      //     {
      //       name: '充电电量（度）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillKwhs : 0
      //     },
      //     {
      //       name: '电费总额（元）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney - res.data.data[0].totalServiceMoney : 0
      //       // res.data.code == 0?res.data.data[0].totalChargeMoney:0
      //     },
      //     {
      //       name: '服务费总额（元）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalServiceMoney : 0
      //     },
      //     {
      //       name: '充电总额（元）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney : 0
      //       //  res.data.code == 0?res.data.data[0].totalChargeMoney*1+res.data.data[0].totalServiceMoney*1:0
      //     },
      //     {
      //       name: '充电优惠总额（元）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalDiscountMoney : 0
      //     },
      //     {
      //       name: '实收总额（元）',
      //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney - res.data.data[0].totalDiscountMoney : 0
      //       // (res.data.data[0].totalChargeMoney*1+res.data.data[0].totalServiceMoney*1) - res.data.data[0].totalDiscountMoney:0
      //     }
      //   ];

      this.powerStationList = [
        {
          id: 0,
          stationName: '全部电站',
        }
      ];
      setTimeout(() => {
        this.chongzhianiu = false;
      }, 500);
      this.$http.get('station-info/getAllStationInfoName', {
        params: acc
      }).then(resb => {
        const ress = resb.data;
        this.powerStationList = [...this.powerStationList, ...ress.data]
      });

    },
    // 展示订单包含子项内容
    async showDetail(id) {
      const { data: res } = await this.$http.get('order/getOrderById?id=' + id)
      if (res.code !== 0) return this.$message.error(res.msg)
      this.detailList = res.data
    },
    // 双击展开折叠
    dbclick(row, column, event) {
      // console.log(event.currentTarget.querySelector(".el-table__expand-icon"))
      if (event.currentTarget.querySelector(".el-table__expand-icon")) {
        event.currentTarget.querySelector(".el-table__expand-icon").click()
      }
    },
    // 结算订单
    async removeById(id) {
      const confirmResult = await this.$confirm('此操作将结算该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消结算！')
      }
      const { data: res } = await this.$http.post('adminLog/delAdminLogById?id=' + id)
      if (res.code !== 0) {
        return this.$message.error('结算失败！')
      }
      this.$message.success('结算成功！')
      this.getPowerStationList()
    }
  }
};
</script>

<style lang="less" scoped>
.historybill {
  width: 99%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.embedded-frame {
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.centerList {
  height: 88vh;
}

.buttons {
  display: flex;
  flex-direction: row;
  color: #fff;
  background-color: #409EFF;
  outline: none;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0px 10px;
  border-radius: 4px;
  height: 35px;
  font-size: 14px;
}

.tils {
  margin: 0px 1% 20px 1%;
  display: flex;
  justify-content: flex-end;
  height: auto;

  button {
    margin-right: 20px;
  }

  button:last-child {
    margin-right: 0;
  }
}

.el-row {
  display: flex;
  flex-direction: column;

  .el-col {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.card {
  width: 100%;
  height: 99%;
  overflow-y: scroll;
  margin-bottom: 1%;
}

.alls {
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  .footer {
    height: 30px;
    margin: 10px 0;
  }

  .center1,
  .center2 {
    display: flex;
    flex-direction: column;

    h4 {
      height: 30px;
      font-size: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    #main1,
    #main2 {
      height: 400px;
      width: 90%;
      margin: 0 5%;
    }
  }
}

.listname {
  display: flex;
  flex-direction: row;
  height: 80px;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
  border: 1px solid gray;
  list-style: none;
  border-radius: 15px;
  font-size: 16px;

  .dl {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;

    .p {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .p:nth-child(1) {
      color: gray;
      // font-size: 16px;
    }

  }

  .dl:last-child {
    margin-right: 0;
  }
}
</style>
<!-- <style lang="less" scoped>
.demo-table-expand {
  color: rgb(52, 115, 250);
}

.demo-table-expand .el-form-item {
  margin: 0 20px;
}
</style><template>
    <div class="historybill">
      <el-form :inline="true" :model="queryInfo" class="form" style="margin-bottom: -10px;">
        <el-row :gutter="24">
          <el-col style="display: flex;flex-direction: row;">
            <el-form-item label="所属电站" label-width="110px" style="display:flex;flex-direction:row;margin-left: -40px;">
              <el-select v-model="suoshudianzhan" placeholder="请选择所属电站" @change="change_value" clearable
                @clear="getPowerStationList" filterable>
                <el-option v-for="(item, index) in powerStationList" :key="index" :label="item.stationName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号|路别" label-width="120px" style="display:flex;flex-direction:row;margin-left: -40px">
              <el-input placeholder="请输入手机号或路别" clearable @change="xiugai" v-model="queryInfo.phone"
                @clear="getPowerStationList">
              </el-input>
            </el-form-item>
            <el-form-item label="车牌号" label-width="110px" style="display:flex;flex-direction:row;margin-left: -70px">
              <el-input placeholder="请输入车牌号" clearable @change="getPowerStationList" v-model="queryInfo.carNum"
                @clear="getPowerStationList">
              </el-input>
            </el-form-item>
            <el-form-item label="Vin主账户" v-if="VinAll.length > 0" label-width="110px"
              style="display:flex;flex-direction:row;margin-left: -50px">
              <el-select v-model="VinMain" placeholder="请选择vin主账户" clearable @clear="getPowerStationList" filterable>
                <el-option v-for="(item, index) in VinAll" :key="index" :label="item.companyName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="微信主账号" label-width="110px" style="display:flex;flex-direction:row;margin-left: -40px">
              <el-input placeholder="请输入微信主账号" clearable @change="xiugai2" v-model="queryInfo.wxPhone"
                @clear="getPowerStationList">
              </el-input>
            </el-form-item>
            <div v-if="!zhuangkuang" style="display: flex;flex-direction: row;margin-left: -10px">
              <li>
                <button @click="chaxun" class="buttons">
                  <i class="el-icon-search" style="font-size: 14px;"></i>
                  <span>查询</span>
                </button>
              </li>
              <li style="margin: 0 10px;">
                <button @click="chongzhi" class="buttons"><i class="el-icon-refresh-right"
                    style="font-size: 14px;"></i><span>重置</span>
                </button>
              </li>
              <li>
                <button @click="jizaigengduo" class="buttons">
                  <i class="el-icon-check" style="font-size: 14px;"></i><span>更多筛选</span>
                </button>
              </li>
            </div>
          </el-col>
          <el-col v-if="zhuangkuang" style="display: flex;flex-direction: row;margin-top: -10px;">
            <el-form-item label="支付方式" label-width="100px" style="display:flex;flex-direction:row">
              <el-select v-model="queryInfo.cardsType" clearable placeholder="请选择支付方式" @clear="getPowerStationList"
                filterable>
                <el-option v-for="(value, key, index) in cardsTypeList" :key="index" :label="value" :value="key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充电车主" label-width="110px" style="display:flex;flex-direction:row">
              <el-input placeholder="请输入充电车主" clearable @change="getPowerStationList" v-model="queryInfo.icCode"
                @clear="getPowerStationList">
              </el-input>
            </el-form-item>
            <el-form-item label="电桩编号" label-width="110px" style="display:flex;flex-direction:row">
              <el-input placeholder="请输入电桩编号" clearable @change="getPowerStationList" v-model="queryInfo.pileCode"
                @clear="getPowerStationList">
              </el-input>
            </el-form-item>
            <el-form-item label="订单编号" label-width="110px" style="display:flex;flex-direction:row">
              <el-input placeholder="请输入订单号" clearable @change="getPowerStationList" v-model="queryInfo.billCode"
                @clear="getPowerStationList" style="width: 400px;">
              </el-input>
            </el-form-item>
            <el-form-item label="桩类型" label-width="100px" style="display:flex;flex-direction:row">
              <el-select v-model="queryInfo.pileType" clearable placeholder="请选择工作状态" @change="chage_zhuangType"
                @clear="getPowerStationList" filterable>
                <el-option v-for="(item, index) in pileType_list" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-select v-model="queryInfo.pileType" placeholder="请选择" @change="chage_zhuangType" filterable clearable
                  @clear="getPowerStationList" style="width: 120px;">
                  <el-option v-for="item in zhuangTypelist" :key="item.pileType" :label="item.stationName"
                    :value="item.pileType">
                  </el-option>
                </el-select> -->
            </el-form-item>
          </el-col>
          <!-- :span="4" -->
          <el-col v-if="zhuangkuang" style="display: flex;flex-direction: row;margin-top: -10px;">
            <el-form-item label="选择时间" label-width="110px" style="display:flex;flex-direction:row">
              <el-date-picker type="datetimerange" @blur="pickBlur" :picker-options="pickerOptions" v-model="values"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']" @change="changeTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="启动方式" label-width="110px" style="display:flex;flex-direction:row">
              <el-select v-model="queryInfo.startType" placeholder="请选择订单启动方式" @change="chage_startType" filterable
                clearable @clear="getPowerStationList">
                <el-option v-for="(item, index) in startTypelist" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式" label-width="110px" style="display:flex;flex-direction:row">
              <el-select v-model="shifou" placeholder="请选择订单支付方式" @change="chage_isPay" filterable clearable
                @clear="getPowerStationList">
                <el-option v-for="(item, index) in isPay" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="无效订单" label-width="110px" style="display:flex;flex-direction:row">
              <el-select v-model="queryInfo.defaultValue" placeholder="请选择订单状态" clearable @change="current"
                @clear="getPowerStationList" filterable>
                <el-option v-for="(item, index) in invalidOrder" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务器类型" label-width="110px" style="display:flex;flex-direction:row">
              <el-select v-model="queryInfo.serverType" placeholder="请选择服务器类型" clearable @change="current"
                @clear="getPowerStationList" filterable>
                <el-option v-for="(item, index) in serverTypeList" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
  
          </el-col>
          <li class="tils" v-if="zhuangkuang">
            <button @click="chaxun" class="buttons">
              <i class="el-icon-search" style="font-size: 12px;"></i><span>查询</span>
            </button>
            <button @click="chongzhi" class="buttons"><i class="el-icon-refresh-right"
                style="font-size: 12px;"></i><span>重置</span></button>
            <button @click="jizaigengduo" class="buttons"><i class="el-icon-check"
                style="font-size: 12px;"></i><span>更多筛选</span></button>
          </li>
        </el-row>
      </el-form>
      <!-- 卡片视图区域 -->
      <el-card class="card">
        <li style="margin-bottom: 10px;display: flex;justify-content: flex-end;margin-top: -10px;">
          <el-button type="primary" icon="el-icon-download" @click="daochu">导出</el-button>
        </li>
        <div class="listname" v-if="listall.length > 0">
          <div class="dl" v-for="(item, index) in listall" :key="index">
            <div class="p">
              {{ item.name }}
            </div>
            <div class="p">
              {{ index !== 0 ? timesalls(item.countMoney, 100, 2) : timesalls(item.countMoney, 100, 4) }}
            </div>
          </div>
        </div>
        <!--  -->
        <!-- table表格区域 -->
        <el-table class="table" :data="chargingList" border @row-dblclick="dbclick" :lazy="true" empty-text="暂无数据">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" class="demo-table-expand">
                <el-row :gutter="20" style="display: flex;flex-direction: row;padding: 0 1%;">
                  <el-col :span="6" style="display: flex;flex-direction: column;">
                    <el-form-item label="订单编号：">
                      <span v-if="scope.row.startType == 5">{{ scope.row.billCode }}</span>
                      <span v-else>{{ time_all(scope.row) }}</span>
                      <span v-if="scope.row.billCode == null">--</span>
                    </el-form-item>
                    <el-form-item label="电桩编号：">
                      <span v-if="scope.row.pileCode">{{ scope.row.pileCode }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                    <el-form-item label="开始时间：">
                      <span v-if="scope.row.startTime">{{ scope.row.startTime }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                    <el-form-item label="结束时间：">
                      <span v-if="scope.row.endTime">{{ scope.row.endTime }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="display: flex;flex-direction: column;">
                    <el-form-item label="充电车主：">
                      <span v-if="scope.row.icCode !== null">{{ scope.row.icCode }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                    <el-form-item label="车牌号：">
                      <span v-if="scope.row.carNum !== null">{{ scope.row.carNum }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                    <el-form-item label="车架号：">
                      <span v-if="scope.row.carvin">{{ scope.row.carvin }}</span>
                      <span v-else> -- </span>
                    </el-form-item>
                    <el-form-item label="结束原因："><span>{{ scope.row.stopReason }}</span></el-form-item>
                  </el-col>
                  <el-col :span="6" style="display: flex;flex-direction: column;">
                    <el-form-item label="尖时电量（度）：">
                      <span v-if="scope.row.tipKwh">{{ timesalls(scope.row.tipKwh, 100, 4) }}度</span>
                      <span v-else> 0 度</span>
                    </el-form-item>
                    <el-form-item label="峰时电量（度）：">
                      <span v-if="scope.row.peakKwh">{{ timesalls(scope.row.peakKwh, 100, 4) }}度</span>
                      <span v-else> 0 度</span>
                    </el-form-item>
                    <el-form-item label="平时电量（度）：">
                      <span v-if="scope.row.flatKwh">{{ timesalls(scope.row.flatKwh, 100, 4) }}度</span>
                      <span v-else> 0 度</span>
                    </el-form-item>
                    <el-form-item label="谷时电量（度）：">
                      <span v-if="scope.row.valleyKwh">{{ timesalls(scope.row.valleyKwh, 100, 4) }}度</span>
                      <span v-else> 0 度</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="display: flex;flex-direction: column;">
                    <el-form-item label="开始SOC：">
                      <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.startSoc"
                        status="success"></el-progress>
                    </el-form-item>
                    <el-form-item label="当前SOC：">
                      <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.nowSoc"
                        status="success"></el-progress>
                    </el-form-item>
                    <el-form-item label="充电时长（分钟）：">
                      <span>{{ timesalls(scope.row.lengthTime, 60, 0) }}分钟</span>
                    </el-form-item>
                    <el-form-item label="扣款方式：">
                      <span>{{ typeNames(scope.row) }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column align="center" label="电桩编号" prop="pileCode" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.pileCode }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="手机号|路别" prop="phone" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.phone == null || scope.row.phone == '' || scope.row.phone == '' ? '--' : scope.row.phone
                }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="枪号" prop="gunNumber" width="70">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.gunNumber == 1 ? '' : scope.row.gunNumber == 2 ? 'success' : scope.row.gunNumber == 3 ? 'warning' : 'danger'"
                v-if="scope.row.gunNumber == 1 || scope.row.gunNumber == 2 || scope.row.gunNumber == 3 || scope.row.gunNumber == 4">{{
        scope.row.gunNumName }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="开始时间" prop="startTime" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime == null ? '--' : scope.row.startTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="结束时间" prop="endTime" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime == null ? '--' : scope.row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="充电SOC" prop="nowSoc" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.nowSoc }}%</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="充电功率" prop="chargeKwh" width="80">
            <template slot-scope="scope">
              <span>{{ jisuan(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="电量（度）" prop="totalKwh" width="100">
            <template slot-scope="scope">
              <span>{{ timesalls(scope.row.totalKwh, 100, 4) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="电费  |  服务费（元）" width="170">
            <template slot-scope="scope">
              <el-col>
                <span>￥{{ timesalls(scope.row.chargemoney, 100, 2) }}&emsp;|&emsp;</span>
                <span
                  v-if="scope.row.chargemoneygive == 0 && scope.row.servicemoneygive == 0 && scope.row.billMoneygive == 0"></span>
                <span>￥{{ timesalls(scope.row.servicemoney, 100, 2) }}</span>
              </el-col>
              <el-col
                v-if="scope.row.chargemoneygive == 0 && scope.row.servicemoneygive == 0 && scope.row.billMoneygive == 0"></el-col>
              <el-col v-else>
                <span style="color: green;font-size: 14px;">
                  ￥{{ timesalls(scope.row.chargemoneygive, 100, 2) }}&emsp;|&emsp;</span>
                <span></span>
                <span style="color: green;font-size: 14px;">
                  ￥{{ timesalls(scope.row.servicemoneygive, 100, 2) }}</span>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column align="center" label="总费用  |  优惠（元）" prop="billMoney" width="170">
            <template slot-scope="scope">
              <span>￥{{ timesalls(scope.row.billMoney, 100, 2) }}&emsp;|&emsp;</span><span
                style="color: green;font-size: 14px;">￥{{ timesalls(scope.row.billMoneygive, 100, 2) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实付金额" width="80">
            <template slot-scope="scope">
              <span>￥{{ shifu(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="启动方式" prop="startType" width="80">
            <template slot-scope="scope">
              <img style="width: 40px;
             height: 40px;" :src="scope.row.startType == 0 || scope.row.startType == 9 ? tupian + '小程序.png' : scope.row.startType == 1 ? tupian + '在线卡.png' : scope.row.startType == 2 ? tupian + '离线卡.png' : scope.row.startType == 3 ? tupian + '管理卡.png' : scope.row.startType == 4 ? tupian + 'Vin.png' : scope.row.startType == 5 ? tupian + 'hlht.png' : scope.row.startType == 6 ? tupian + 'zfb.png' :
        scope.row.startType == 9 ? tupian + 'app.png' : tupian + 'ocpp_App.png'" alt="">
            </template>
          </el-table-column>
          <el-table-column align="left" label="所属电站" prop="stationName" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span>
                {{ scope.row.stationName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否支付" prop="payState" width="80">
            <template slot-scope="scope">
              <el-tag type="info">{{ scope.row.payTypeName }}</el-tag>
            </template>
          </el-table-column>
          <!-- v-if="qushitu" -->
          <el-table-column width="120" label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- <el-button type="info" size="small" @click="editMethods(scope.row)">修改订单状态</el-button> -->
              <span v-if="scope.row.pileType == 5 || scope.row.pileType == 6 || scope.row.pileType == 7"></span>
              <el-button type="primary" size="small" @click="EleticMask(scope.row)" v-else>充电趋势图</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页导航区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[6, 20, 50, 100]" :current-page="queryInfo.page" :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total" background>
        </el-pagination>
      </el-card>
      <!-- @open="open" -->
      <el-dialog title="电量电流趋势图" :visible.sync="diaload" width="80%" top='1vh' :lock-scroll="false" @close="closeMethods">
        <div class="centerList">
          <iframe :src="embeddedUrl" class="embedded-frame" frameborder="0" scrolling="auto">
          </iframe>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import caozuo from "@/utils/pubilc.js";
  import { saveBlobToFile } from '@/utils/saveBlobToFile';
  import * as echarts from 'echarts';
  export default {
    name: 'chargingWorld',
    data() {
      return {
        embeddedUrl: '',
        serverTypeList: [
          {
            value: 0,
            label: 'PHP'
          },
          {
            value: 1,
            label: 'Netty'
          },
        ],
        qushitu: false,
        diaload: false,
        timeJson: [],
        VinMain: null,
        VinAll: [],
        // 需求电流
        currentDemandJson: [],
        // 需求电压
        requiredVoltageJson: [],
        // 满足电流
        outputCurrentJson: [],
        // 满足电压
        outputVoltageJson: [],
        // 电压输出
        voltageOutputValueJson: [],
        // 电流输出满足率
        outputCurrentRateJson: [],
        // 电压输出满足率
        outputVoltageRateJson: [],
        // 输出电流功率
        outputPowerJson: [],
        // 輸出电压功率
        outputYaJson: [],
        listall: [],
        caozuoquanxian: false,
        zhuangkuang: false,
        values: ['', ''],
        shifou: null,
        daochuanniu: false,
        chongzhianiu: false,
        chaxuananiu: false,
        pileType_list: [
          {
            value: 0,
            label: '锐创直流桩'
          },
          {
            value: 1,
            label: '锐创交流桩'
          },
          {
            value: 2,
            label: '无疆(二代)交流桩'
          },
          {
            value: 3,
            label: '光法(一代)直流桩'
          },
          {
            value: 4,
            label: '光法(一代)交流桩'
          },
          {
            value: 5,
            label: '锐创低速桩'
          },
          {
            value: 6,
            label: '其他电桩'
          }
        ],
        // zhuangTypelist: [],
        startTypelist: [
          {
            label: "小程序",
            value: 0
          },
          {
            label: "在线卡",
            value: 1
          },
          {
            label: "离线卡",
            value: 2
          },
          {
            label: "管理卡",
            value: 3
          },
          {
            label: "Vin",
            value: 4
          },
          {
            label: "互联互通",
            value: 5
          }, {
            label: "支付宝",
            value: 6
          },
          {
            label: "APP",
            value: 9
          },
          {
            label: "OCPP_APP",
            value: 9
          },
        ],
        tupian: this.$imgUrls,
        maxValue: 0,
        // 查询充电订单列表所需参数
        queryInfo: {
          defaultValue: null,
          billCode: null,
          pileCode: null,
          pileType: null,
          gunState: '0,3,4,5,6,7',
          userNum: null,
          icCode: null,
          payState: null,
          startTime: null,
          endTime: null,
          carNum: null,
          page: 1,
          limit: 6,
          stationIds: null,
          roleId: window.sessionStorage.getItem('roleId'),
          startType: null,
          phone: null,
          billInfoType: 0,
          wxPhone: null,
          cardsType: '',
          serverType: null
        },
        socJson: '',
        page_num: 0,
        // 充电订单数据
        chargingList: [],
        stateName: '',
        total: 0,
        value: '',
        detailList: [],
        pickerMinDate: '',
        cardsTypeList: {
          0: '账户余额',
          1: '亲情钱包',
          2: '即充即退',
          3: '绑定金额',
          4: '离线刷卡',
          5: '在线刷卡',
          6: '超级卡',
          7: 'VIN',
          8: '其他',
          9: '互联互通',
        },
        pickerOptions: {
          onPick: obj => {
            this.pickerMinDate = new Date(obj.minDate).getTime()
            const start = this.formatDate(obj.minDate, 'start')
            const end = this.formatDate(obj.maxDate, 'end')
            obj.maxDate && (this.values = [start, end])
          },
          disabledDate: time => {
            if (this.pickerMinDate) {
              const oneMonth = 1000 * 3600 * 24 * 31
              const maxTime = this.pickerMinDate + oneMonth
              const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
              const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
              return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
            }
          }
        },
        // 电站列表数据
        powerStationList: [],
        shuchufalse: [],
        // 是否已支付
        isPay: [
          {
            label: "已支付",
            value: 1
          },
          {
            label: "未支付",
            value: 0
          }
        ],
        maxValue2: 0,
        // 是否无效订单数据
        invalidOrder: [
          {
            label: "是",
            value: 0
          },
          {
            label: "否",
            value: 1
          }
        ],
        suoshudianzhan: 0,
      }
    },
    computed: {
      typeNames() {
        return function (val) {
          const { cardsType } = val;
          return this.cardsTypeList[Number(cardsType)] || '未知类型'
        }
      },
      time_all() {
        return function (val) {
          const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
          return hr
        }
      },
      timesalls() {
        return function (value, num, count) {
          return (value / num).toFixed(count)
        }
      },
      shifu() {
        return function (val) {
          return ((val.billMoney - val.billMoneygive - val.chargemoneygive - val.servicemoneygive) / 100).toFixed(2)
        }
      },
      jisuan() {
        return function (val) {
          return val.chargeKwh == null || val.chargeKwh == undefined || val.chargeKwh == '' ? 0 : val.pileType !== 5 ? (val.chargeKwh / 100000).toFixed(4) : val.chargeKwh
        }
      }
    },
    watch: {
      chargingList: {
        handler(newval, oldval) {
          this.chargingList = newval
        }
      }
    },
    created() {
      caozuo(244).then(res => {
        this.qushitu = res;
      });
      caozuo(165).then(res => {
        this.caozuoquanxian = res;
      })
      this.VinGet();
      this.getPowerStationList()
    },
    methods: {
      xiugai() {
        const { phone } = this.queryInfo;
        if (!phone || phone == undefined || phone == '') {
          this.$delete(this.queryInfo, 'phone');
        }
        this.getPowerStationList()
      },
      xiugai2() {
        const { wxPhone } = this.queryInfo;
        if (!wxPhone || wxPhone == undefined || wxPhone == '') {
          this.$delete(this.queryInfo, 'wxPhone');
        }
        this.queryInfo.startType = !this.queryInfo.startType || this.queryInfo.startType == undefined || this.queryInfo.startType == '' ? 0 : this.queryInfo.startType;
        this.getPowerStationList();
      },
      VinGet() {
        const stationIds = window.sessionStorage.getItem('stationIds');
        const roleId = window.sessionStorage.getItem('roleId');
        const adminId = window.sessionStorage.getItem('adminId');
        var abc = {
          roleId: roleId,
          stationIds: stationIds,
          adminId: adminId,
          limit: 100
        }
        if (!this.suoshudianzhan || this.suoshudianzhan == '' || this.suoshudianzhan == 0) {
          if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
            this.$delete(abc, 'stationIds')
          } else {
            abc.stationIds = stationIds
          }
        }
        // this.VinAll = [
        //   {
        //     id: 0,
        //     stationName: '全部电站',
        //   }
        // ];
  
        this.$http.get('charge-vin-total/getAllChargeVinTotal', {
          params: abc
        }).then(res => {
          const ress = res.data;
          if (ress.code > 0) return this.VinAll = [];
          this.VinAll = ress.data
        })
      },
      closeMethods() {
        this.diaload = false;
        const myChart1 = document.getElementById('main1');
        const myChart2 = document.getElementById('main2');
        if (myChart1) {
          echarts.init(myChart1).clear();
        }
        if (myChart2) {
          echarts.init(myChart2).clear();
        }
      },
      editMethods(el) {
        this.$http.post('bill-info/updateStatusById', {
          id: el.id,
          payState: 1
        }).then(res => {
          this.$message.success('订单状态修改成功！')
          // console.log(res,678);
        })
      },
      EleticMask(el) {
        const { billCode } = el;
        const abc = window.sessionStorage.getItem('开发模式');
        const ace = {
          'PROD': 'https://sendnetty.rcdqiot.com/',
          'TEST': 'http://1.193.163.25:8711/'
        }
        this.embeddedUrl = ace[abc] + 'charge_curve.html?billCode=' + billCode;
        this.diaload = true;
        console.log(this.embeddedUrl, 675)
      },
      pickBlur() {
        this.pickerMinDate = ''
      },
      formatDate(datetime, type) {
        const time = new Date(datetime)
        const year = time.getFullYear()
        const month = (time.getMonth() + 1).toString().padStart(2, '0')
        const date = (time.getDate()).toString().padStart(2, '0')
        return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
      },
      getDate() {
        const start = new Date()
        this.values[0] = this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30, 'start')
        this.values[1] = this.formatDate(start.getTime(), 'end')
      },
      zhanshi() {
        this.yincang = !this.yincang
      },
      daochu() {
        const { startTime, endTime, phone, startType, carNum, carvin, pileCode, icCode, wxPhone } = this.queryInfo;
        if (!startTime || !endTime) {
          this.$message.error('请选择你要导出的电站、时间');
          return;
        }
        const roleId = window.sessionStorage.getItem('roleId');
        let obj = {
          startTime: startTime,
          endTime: endTime,
          stationIds: this.suoshudianzhan,
          adminId: window.sessionStorage.getItem('adminId') * 1,
          phone: phone,
          startType: startType,
          carNum: carNum,
          carvin: carvin,
          pileCode: pileCode,
          icCode: icCode,
          wxPhone: wxPhone
        };
        if (this.suoshudianzhan == 0) {
          if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
            this.$delete(obj, 'stationIds');
            this.$message.error('导出请选择场站！')
            return;
          } else {
            obj.stationIds = window.sessionStorage.getItem('stationIds')
          }
        }
        if (!carvin || carvin == '') {
          this.$delete(obj, 'carvin');
          this.$delete(this.queryInfo, 'carvin');
        }
        // if (this.wxPhone !== null && this.wxPhone !== '') {
        //   obj.phone = this.phoneMain
        // }
        if (this.VinMain !== null && this.VinMain !== '') {
          obj.cardsId = this.VinMain;
          obj.startType = 4;
        } else {
          this.$delete(obj, 'cardsId')
        }
        console.log(obj, '974');
        if (obj.startType == 4) {
          // if (obj.phone == '' || obj.phone == null) return this.$message.error('请输入需要导出的路别')
          this.com1(obj);
        } else {
          this.com1(obj)
        }
  
      },
      com1(obj) {
        console.log(obj, '950');
        this.$http.get('bill-info/export', {
          responseType: 'blob',
          params: obj
        }).then(res => {
          if (res.headers['content-type']?.includes('application/json')) {
            this.$message.error('无符合条件的订单！');
          } else {
            saveBlobToFile(res.data, '历史订单电站列表');
            this.$message.success('文件导出成功');
          }
        })
      },
      jizaigengduo() {
        this.zhuangkuang = !this.zhuangkuang;
      },
  
      changeTime(value) {
        this.queryInfo.page = 1;
        if (value) {
          this.queryInfo.startTime = value[0];
          this.queryInfo.endTime = value[1];
          if (this.queryInfo.startTime == this.queryInfo.endTime) {
            this.$message.error('起始时间不得为同一天！');
            this.queryInfo.startTime = ''
            this.queryInfo.endTime = ''
          }
        } else {
          this.queryInfo.startTime = null
          this.queryInfo.endTime = null
          this.pickerMinDate = '';
          this.getPowerStationList()
        }
      },
      change_value(e) {
        this.queryInfo.page = 1;
        if (e !== null || e !== undefined) {
          this.queryInfo.stationIds = e;
        }
      },
      // 启动方式
      chage_startType(e) {
        this.queryInfo.page = 1;
        if (e !== null || e !== undefined) {
          this.queryInfo.startType = e;
          // this.queryInfo.pileType = e;
        }
      },
      // 桩类型
      chage_zhuangType(e) {
        this.queryInfo.page = 1;
        if (e !== null || e !== undefined) {
          // this.queryInfo.startType = e;
          this.queryInfo.pileType = e;
        }
      },
      current() {
        this.queryInfo.page = 1;
      },
      // 支付方式
      chage_isPay(e) {
        this.queryInfo.page = 1;
        if (e !== null || e !== undefined) {
          this.queryInfo.payState = e;
        }
      },
      // 重置搜索条件
      chongzhi() {
        this.chongzhianiu = true;
        this.VinMain = null;
        this.queryInfo = {
          defaultValue: null,
          billCode: null,
          pileCode: null,
          pileType: null,
          gunState: '0,3,4,5,6,7',
          userNum: null,
          icCode: null,
          payState: null,
          startTime: null,
          endTime: null,
          page: 1,
          limit: 6,
          stationIds: null,
          roleId: window.sessionStorage.getItem('roleId'),
          startType: null,
          carNum: null,
          phone: null,
          billInfoType: 0,
          wxPhone: '',
          cardsType: '',
          serverType: null
        };
        this.shifou = '';
        this.suoshudianzhan = 0;
        this.values = [];
        this.pickerMinDate = '';
        this.getPowerStationList();
        setTimeout(() => {
          this.chongzhianiu = false;
        }, 500);
      },
      chaxun() {
        this.chaxuananiu = true;
        this.queryInfo.page = 1;
        this.getPowerStationList();
      },
      // 监听pageSize改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.limit = newSize;
        this.getPowerStationList()
      },
      // 监听页码值改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.page = newPage;
        this.getPowerStationList()
      },
      // 获取电站列表数据
      getPowerStationList() {
        const stationIds = window.sessionStorage.getItem('stationIds');
        const roleId = window.sessionStorage.getItem('roleId');
        this.chargingList = [];
        this.listall = [];
        // if (this.queryInfo.stationIds == null || this.queryInfo.stationIds == undefined) return;
        if (this.queryInfo.billCode !== null && this.queryInfo.billCode !== '' && this.queryInfo.billCode !== undefined) {
          this.queryInfo.billCode = this.queryInfo.billCode.trim().split(" ").join("");
        }
        if (this.queryInfo.icCode !== null && this.queryInfo.icCode !== '' && this.queryInfo.icCode !== undefined) {
          this.queryInfo.icCode = this.queryInfo.icCode.trim().split(" ").join("");
        }
        if (!this.queryInfo.serverType) {
          this.$delete(this.queryInfo, 'serverType')
        }
  
        let ntr = this.queryInfo;
        let obj = {
          roleId: roleId,
          stationIds: this.suoshudianzhan == 0 ? stationIds : this.suoshudianzhan,
          startTime: ntr.startTime,
          endTime: ntr.endTime,
          icCode: ntr.icCode,
          phone: ntr.phone,
          payState: ntr.payState,
          startType: ntr.startType,
          pileCode: ntr.pileCode,
          wxPhone: ntr.wxPhone,
          cardsId: this.VinMain,
          adminId: window.sessionStorage.getItem('adminId'),
          cardsType: ntr.cardsType
        };
        if (!this.queryInfo.startTime || !this.queryInfo.endTime) {
          this.$delete(this.queryInfo, 'startTime')
          this.$delete(this.queryInfo, 'endTime')
          this.$delete(ntr, 'startTime')
          this.$delete(ntr, 'endTime')
          this.$delete(obj, 'startTime')
          this.$delete(obj, 'endTime')
        }
        if (!this.queryInfo.cardsType || this.queryInfo.cardsType == '') {
          this.$delete(this.queryInfo, 'cardsType')
          this.$delete(ntr, 'cardsType')
          this.$delete(obj, 'cardsType')
        }
        let acc = {
          roleId: roleId,
          stationIds: stationIds,
          stationMode: '0,1,2'
        }
        if (this.VinMain !== null && this.VinAll !== '') {
          ntr.cardsId = this.VinMain;
          ntr.startType = 4;
        } else {
          this.$delete(ntr, 'cardsId')
        }
  
        if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) { this.$delete(acc, 'stationIds') }
        if (!this.suoshudianzhan || this.suoshudianzhan == '' || this.suoshudianzhan == 0) {
          if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 10) {
            this.$delete(this.queryInfo, 'stationIds')
            this.$delete(ntr, 'stationIds')
            this.$delete(obj, 'stationIds')
  
          } else {
            ntr.stationIds = stationIds;
          }
        }
        this.$http.get('bill-info/getAllBillInfo', { params: ntr }).then(res => {
          this.chargingList = res.data.code == 0 ? res.data.data : [];
          this.total = res.data.code == 0 ? res.data.count : 0;
        });
  
        this.$http.get('bill-info/getAllBillInfoCount', {
          params: obj
        }).then(ress => {
          const res1 = ress.data;
          this.listall = [
            {
              name: '充电电量（度）',
              countMoney: res1.code == 0 ? res1.data.totalBillKwhs : 0
            },
            {
              name: '电费总额（元）',
              countMoney: res1.code == 0 ? res1.data.totalBillMoney - res1.data.totalServiceMoney : 0
            },
            {
              name: '服务费总额（元）',
              countMoney: res1.code == 0 ? res1.data.totalServiceMoney : 0
            },
            {
              name: '充电总额（元）',
              countMoney: res1.code == 0 ? res1.data.totalBillMoney : 0
            },
            {
              name: '充电优惠总额（元）',
              countMoney: res1.code == 0 ? res1.data.totalDiscountMoney : 0
            },
            {
              name: '实收总额（元）',
              countMoney: res1.code == 0 ? res1.data.totalBillMoney - res1.data.totalDiscountMoney : 0
            }
          ];
        })
        // this.listall = [
        //     {
        //       name: '充电电量（度）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillKwhs : 0
        //     },
        //     {
        //       name: '电费总额（元）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney - res.data.data[0].totalServiceMoney : 0
        //       // res.data.code == 0?res.data.data[0].totalChargeMoney:0
        //     },
        //     {
        //       name: '服务费总额（元）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalServiceMoney : 0
        //     },
        //     {
        //       name: '充电总额（元）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney : 0
        //       //  res.data.code == 0?res.data.data[0].totalChargeMoney*1+res.data.data[0].totalServiceMoney*1:0
        //     },
        //     {
        //       name: '充电优惠总额（元）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalDiscountMoney : 0
        //     },
        //     {
        //       name: '实收总额（元）',
        //       countMoney: res.data.code == 0 ? res.data.data[0].totalBillMoney - res.data.data[0].totalDiscountMoney : 0
        //       // (res.data.data[0].totalChargeMoney*1+res.data.data[0].totalServiceMoney*1) - res.data.data[0].totalDiscountMoney:0
        //     }
        //   ];
  
        this.powerStationList = [
          {
            id: 0,
            stationName: '全部电站',
          }
        ];
        setTimeout(() => {
          this.chongzhianiu = false;
        }, 500);
        this.$http.get('station-info/getAllStationInfoName', {
          params: acc
        }).then(resb => {
          const ress = resb.data;
          this.powerStationList = [...this.powerStationList, ...ress.data]
        });
  
      },
      // 展示订单包含子项内容
      async showDetail(id) {
        const { data: res } = await this.$http.get('order/getOrderById?id=' + id)
        if (res.code !== 0) return this.$message.error(res.msg)
        this.detailList = res.data
      },
      // 双击展开折叠
      dbclick(row, column, event) {
        // console.log(event.currentTarget.querySelector(".el-table__expand-icon"))
        if (event.currentTarget.querySelector(".el-table__expand-icon")) {
          event.currentTarget.querySelector(".el-table__expand-icon").click()
        }
      },
      // 结算订单
      async removeById(id) {
        const confirmResult = await this.$confirm('此操作将结算该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        if (confirmResult !== 'confirm') {
          return this.$message.info('已经取消结算！')
        }
        const { data: res } = await this.$http.post('adminLog/delAdminLogById?id=' + id)
        if (res.code !== 0) {
          return this.$message.error('结算失败！')
        }
        this.$message.success('结算成功！')
        this.getPowerStationList()
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .historybill {
    width: 99%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  
  .embedded-frame {
    width: 100%;
    height: 100%;
    min-height: 400px;
  }
  
  .centerList {
    height: 88vh;
  }
  
  .buttons {
    display: flex;
    flex-direction: row;
    color: #fff;
    background-color: #409EFF;
    outline: none;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0px 10px;
    border-radius: 4px;
    height: 35px;
    font-size: 14px;
  }
  
  .tils {
    margin: 0px 1% 20px 1%;
    display: flex;
    justify-content: flex-end;
    height: auto;
  
    button {
      margin-right: 20px;
    }
  
    button:last-child {
      margin-right: 0;
    }
  }
  
  .el-row {
    display: flex;
    flex-direction: column;
  
    .el-col {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  
  .card {
    width: 100%;
    height: 99%;
    overflow-y: scroll;
    margin-bottom: 1%;
  }
  
  .alls {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  
    .footer {
      height: 30px;
      margin: 10px 0;
    }
  
    .center1,
    .center2 {
      display: flex;
      flex-direction: column;
  
      h4 {
        height: 30px;
        font-size: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
  
      #main1,
      #main2 {
        height: 400px;
        width: 90%;
        margin: 0 5%;
      }
    }
  }
  
  .listname {
    display: flex;
    flex-direction: row;
    height: 80px;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 20px;
    border: 1px solid gray;
    list-style: none;
    border-radius: 15px;
    font-size: 16px;
  
    .dl {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
  
      .p {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
  
      .p:nth-child(1) {
        color: gray;
        // font-size: 16px;
      }
  
    }
  
    .dl:last-child {
      margin-right: 0;
    }
  }
  </style>
  <!-- <style lang="less" scoped>
  .demo-table-expand {
    color: rgb(52, 115, 250);
  }
  
  .demo-table-expand .el-form-item {
    margin: 0 20px;
  }
  </style>